export default __webpack_public_path__ + "static/media/single-border-right.5f176ac5.svg";